import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from 'vuex-persistedstate'
import SecureLS from "secure-ls";

import parametricsearch from "./parametricsearch.module";
import comparepage from "./compare-page.module";
import recommendeddriver from "./recommended-driver.module";
import usermanagement from "./user-management.module";
import mydocuments from "./my-documents.module";
import myadmin from "./my-admin.module";
import mysupport from "./my-support.module";

Vue.use(Vuex);
const ls = new SecureLS({isCompression: false});

export default new Vuex.Store({
    modules: {
        parametricSearch: parametricsearch,
        comparePage: comparepage,
        recomendedDriver: recommendeddriver,
        userManagement: usermanagement,
        mySupport: mysupport,
        myDocuments: mydocuments,
        myAdmin: myadmin
    },
    plugins: [
        createPersistedState({
            storage: {
                getItem: key => ls.get(key),
                setItem: (key, value) => ls.set(key, value),
                removeItem: key => ls.remove(key)
            }
        }),
        createPersistedState({
            key: 'user',
            paths: ["userManagement.user.firstName", "userManagement.user.lastName"],
            storage: {
                getItem: key => window.localStorage.getItem(key),
                setItem: (key, value) => {
                    window.localStorage.setItem(key, value);
                    let event;
                    if (typeof (Event) === 'function') {
                        event = new Event('storage');
                    } else {
                        event = document.createEvent('Event');
                        event.initEvent('storage', true, true);
                    }
                    window.dispatchEvent(event);
                },
                removeItem: key => window.localStorage.removeItem(key)
            }
        })
    ]
});
